var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ApiCallService } from './api-call.service';
import { BaseApiService } from './base-api.service';
var SimpleLimitsService = /** @class */ (function (_super) {
    __extends(SimpleLimitsService, _super);
    function SimpleLimitsService(apiCallService) {
        var _this = _super.call(this) || this;
        _this.apiCallService = apiCallService;
        return _this;
    }
    SimpleLimitsService.prototype.getSimpleLimits = function () {
        return this.apiCallService.get('/new_properties/simple_limits');
    };
    SimpleLimitsService.prototype.resolve = function (route) {
        var promise = this.getSimpleLimits();
        return promise;
    };
    SimpleLimitsService.prototype.ng2SelectItems = function (cities) {
        return cities.map(function (city) {
            return {
                text: city.name,
                children: city.zones.map(function (zone) {
                    return {
                        id: zone.id,
                        text: zone.name
                    };
                })
            };
        });
    };
    SimpleLimitsService.prototype.ng2SelectedItems = function (cities, zoneId) {
        for (var cityIndex in cities) {
            if (cities.hasOwnProperty(cityIndex)) {
                for (var zoneIndex in cities[cityIndex].zones) {
                    if (cities[cityIndex].zones.hasOwnProperty(zoneIndex) && +zoneId === +cities[cityIndex].zones[zoneIndex]['id']) {
                        return [{ id: cities[cityIndex].zones[zoneIndex]['id'], text: cities[cityIndex].zones[zoneIndex]['name'] }];
                    }
                }
            }
        }
        return null;
    };
    SimpleLimitsService.prototype.ngSelectItems = function (cities) {
        var array = [];
        cities.forEach(function (city) {
            city.zones.forEach(function (zone) {
                array.push({
                    id: zone.id,
                    name: zone.name,
                    city: city.name
                });
            });
        });
        return array;
    };
    return SimpleLimitsService;
}(BaseApiService));
export { SimpleLimitsService };



// WEBPACK FOOTER //
// ./src/app/common-theme/api/simple-limits.service.ts.pre-build-optimizer.js